const translations = {
    // Header
    home: "ទំព័រដើម",
    mail: "សារ",
    calendar: "ប្រតិទិន",
    chat: "ជជែក",
    cart: "រទេះ",
    tickets: "សំបុត្រ",
    video: "វីដេអូ",
    aboutUs: "អំពីយើង",
    vendor: "អ្នកលក់",
    price: "តម្លៃ",
    pictures: "រូបភាព",
    downloadApp: "ទាញយកកម្មវិធី",
    menu: "ម៉ឺនុយ",
    quickActions: "សកម្មភាពរហ័ស",
    language: "ភាសា",

    // Common
    close: "បិទ",
    cancel: "បោះបង់",
    save: "រក្សាទុក",
    delete: "លុប",
    edit: "កែប្រែ",
    add: "បន្ថែម",
    search: "ស្វែងរក",
    submit: "ដាក់ស្នើ",
    loading: "កំពុងផ្ទុក...",
    error: "កំហុស",
    success: "ជោគជ័យ",
    confirm: "បញ្ជាក់",
    yes: "បាទ",
    no: "ទេ",
    back: "ត្រលប់",
    next: "បន្ទាប់",
    previous: "មុន",
    view: "មើល",
    details: "ព័ត៌មានលម្អិត",
    filter: "ត្រង",
    reset: "កំណត់ឡើងវិញ",
    export: "នាំចេញ",
    import: "នាំចូល",
    print: "បោះពុម្ព",
    download: "ទាញយក",
    upload: "ផ្ទុកឡើង",
    select: "ជ្រើស",
    selectAll: "ជ្រើសទាំងអស់",
    clear: "សម្អាត",
    apply: "អនុវត្ត",
    update: "ធ្វើបច្ចុប្បន្នភាព",
    create: "បង្កើត",
    new: "ថ្មី",
    viewAll: "មើលទាំងអស់",
    showMore: "បង្ហាញបន្ថែម",
    showLess: "បង្ហាញតិច",

    // User
    user: "អ្នកប្រើប្រាស់",
    profile: "ប្រូហ្វាល",
    settings: "ការកំណត់",
    logout: "ចេញ",
    login: "ចូល",
    username: "ឈ្មោះអ្នកប្រើ",
    password: "ពាក្យសម្ងាត់",
    email: "អ៊ីម៉ែល",
    phone: "ទូរស័ព្ទ",
    name: "ឈ្មោះ",
    id: "លេខសម្គាល់",

    // Notifications
    notifications: "ការជូនដំណឹង",
    noNotifications: "គ្មានការជូនដំណឹង",

    // Language names
    english: "English",
    khmer: "ខ្មែរ",
    chinese: "ចិន",
    switchToEnglish: "ប្តូរទៅកំណែភាសាអង់គ្លេស",
    switchToChinese: "ប្តូរទៅកំណែភាសាចិន",

    // Sections
    administration: "រដ្ឋបាល",
    managementDashboard: "ផ្ទាំងគ្រប់គ្រង",
    operations: "ប្រតិបត្តិការ",

    // Module Groups
    accountant: "គណនេយ្យ",
    admin: "រដ្ឋបាល",
    hr: "HR",
    csr: "CSR",
    egov: "E-GOV",
    qa: "QA",
    internalLogistics: "ឡូជីស្ទិកខាងក្នុង",
    production: "ផលិតកម្ម",

    // Modules - Administration
    eInvoicing: "វិក្កយបត្រអេឡិចត្រូនិច",
    purchaseRequest: "សំណើទិញ",
    yShop: "Y Shop",
    supportTicket: "សំបុត្រគាំទ្រ",
    billRecord: "កំណត់ត្រាវិក្កយបត្រ",
    gatePass: "លិខិតឆ្លងកាត់",
    meetingRoom: "បន្ទប់ប្រជុំ",
    myCarBooking: "ការកក់រថយន្តរបស់ខ្ញុំ",
    fireAlarm: "ការព្រមានភ្លើង",
    cctv: "CCTV",
    yhr: "YHR",
    salaryBill: "វិក្កយបត្រប្រាក់ខែ",
    orgChart: "តារាងអង្គភាព",
    training: "ការបណ្តុះបណ្តាល",
    tempWorkRequest: "សំណើការងារបណ្តោះអាសន្ន",
    speakUp: "Speak Up",
    digitalAudit: "សវនកម្មឌីជីថល",
    energy: "ថាមពល",
    air: "ខ្យល់",
    water: "ទឹក",
    waste: "កាកសំណល់",
    chemical: "គីមី",
    eGovernment: "រដ្ឋាភិបាលអេឡិចត្រូនិច",
    systemAnalysis: "ការវិភាគប្រព័ន្ធ",

    // Modules - Operations
    yqms: "YQMS",
    callOut: "ការហៅ",
    fc: "FC",
    pwip: "PWIP",
    kanban: "កាន់បាន",
    ce: "CE",
    ytpm: "YTPM",
    ytmShop: "ហាង YTM",
    dtSync: "DT សមកាល",
    masterPlan: "ផែនការមេ",
    linePlan: "ផែនការបន្ទាត់",
    ppm: "PPM",
    tecPack: "TEC PACK",
    pps: "PPS",
    sample: "គំរូ",
    materialPurchase: "ការទិញសម្ភារៈ",

    // Sub-modules - YHR
    recruitment: "ការជ្រើសរើស",
    interview: "ការស meeting",
    onboarding: "ការចូលធ្វើការ",
    attendant: "អ្នកចូលរួម",
    benefitProfile: "ប្រូហ្វាលអត្ថប្រយោជន៍",
    payroll: "ប្រាក់ខែ",
    nssf: "NSSF",
    visaAndWorkPermit: "វីសានិងលិខិតអនុញ្ញាតធ្វើការ",
    fwcms: "FWCMS",
    canteen: "ភោជនីយដ្ឋាន",

    // Sub-modules - Training Departments
    onlineTraining: "ការបណ្តុះបណ្តាលអនឡាញ",
    yai: "YAI",
    it: "IT",
    shipping: "ការដឹកជញ្ជូន",
    ppc: "PPC",
    merchandising: "ការលក់",
    purchasing: "ការទិញ",
    generalAffairs: "កិច្ចការទូទៅ",
    financial: "ហិរញ្ញវត្ថុ",
    cbsa: "CBSA",
    technical: "បច្ចេកទេស",
    rawMaterialWarehouse: "ឃ្លាំងសម្ភារៈដើម",
    cutting: "កាត់",
    scc: "SCC",
    sewing: "កាត់ដេរ",
    qc: "QC",
    ironing: "អ៊ុត",
    packing: "វេចខ្ចប់",
    washing: "លាង",
    tpm: "TPM",
    warehouse: "ឃ្លាំង",
    ie: "IE",
    qaFabric: "QA (ក្រណាត់)",

    // Sub-modules - YTM
    ytm: "YTM",
    machineLocation: "ទីតាំងម៉ាស៊ីន",
    tv: "TV",
    transfers: "ការផ្ទេរ",
    setupAndRepair: "ការដំឡើងនិងជួសជុល",
    routineMaintenance: "ការថែទាំជាប្រចាំ",
    systemSetup: "ការកំណត់ប្រព័ន្ធ",
    data: "ទិន្នន័យ",
    downloadData: "ទាញយក",
    analysis: "ការវិភាគ",
    report: "របាយការណ៍",

    // Additional YHR sub-modules
    checklistAttendant: "Checklist Attendant",
    myAttendant: "My Attendant",
    fwcmsPortal: "FWCMS Portal",
    ministryOfLabour: "ក្រសួងការងារ",

    // Form Labels - Common
    date: "កាលបរិច្ឆេទ",
    time: "ពេលវេលា",
    status: "ស្ថានភាព",
    type: "ប្រភេទ",
    category: "ប្រភេទ",
    description: "ការពិពណ៌នា",
    remarks: "ចំណាំ",
    notes: "កំណត់ចំណាំ",
    comment: "មតិ",
    attachment: "ឯកសារភ្ជាប់",
    file: "ឯកសារ",
    image: "រូបភាព",
    quantity: "បរិមាណ",
    amount: "ចំនួន",
    total: "សរុប",
    subtotal: "សរុបរង",
    unit: "ឯកតា",
    unitPrice: "តម្លៃឯកតា",

    // Form Labels - Purchase Request
    purchaseRequisitionForm: "ទម្រង់សំណើទិញ",
    purchaseList: "បញ្ជីទិញ",
    requester: "អ្នកស្នើ",
    requestBy: "ស្នើដោយ",
    department: "នាយកដ្ឋាន",
    expectDeliveryDate: "កាលបរិច្ឆេទដឹកជញ្ជូនរំពឹង",
    reference: "ឯកសារយោង",
    purchaseType: "ប្រភេទទិញ",
    topic: "ប្រធានបទ",
    paymentType: "ប្រភេទបង់ប្រាក់",
    purchaseBy: "ទិញដោយ",
    productName: "ឈ្មោះផលិតផល",
    productDetails: "ព័ត៌មានលម្អិតផលិតផល",
    brand: "ម៉ាក",
    qty: "បរិមាណ",
    uom: "ឯកតារង្វាស់",
    supplier: "អ្នកផ្គត់ផ្គង់",
    localPurchase: "ទិញក្នុងស្រុក",
    importPurchase: "ទិញនាំចូល",
    both: "ទាំងពីរ",
    newPurchase: "ទិញថ្មី",
    replacement: "ជំនួស",
    repair: "ជួសជុល",
    prePaid: "បង់មុន",
    postPaid: "បង់ក្រោយ",
    buyByMyself: "ទិញដោយខ្លួនឯង",
    buyByCompany: "ទិញដោយក្រុមហ៊ុន",
    head: "ប្រធាន",
    gm: "GM",
    purchaser: "អ្នកទិញ",
    stationery: "សម្ភារៈការិយាល័យ",

    // Form Labels - Support Ticket
    subject: "ប្រធានបទ",
    nature: "ធម្មជាតិ",
    keyword: "ពាក្យគន្លឹះ",

    // Status
    active: "សកម្ម",
    inactive: "អសកម្ម",
    pending: "កំពុងរង់ចាំ",
    approved: "បានអនុម័ត",
    rejected: "បានបដិសេធ",
    completed: "បានបញ្ចប់",
    inProgress: "កំពុងដំណើរការ",
    cancelled: "បានលុបចោល",
    comingSoon: "នឹងមកដល់ឆាប់ៗ",

    // Messages
    noData: "គ្មានទិន្នន័យ",
    noResults: "គ្មានលទ្ធផល",
    pleaseWait: "សូមរង់ចាំ...",
    areYouSure: "តើអ្នកប្រាកដទេ?",
    operationSuccessful: "ប្រតិបត្តិការជោគជ័យ",
    operationFailed: "ប្រតិបត្តិការបរាជ័យ",
    requiredField: "វាលនេះត្រូវការ",
    invalidInput: "ការបញ្ចូលមិនត្រឹមត្រូវ",

    // Time
    today: "ថ្ងៃនេះ",
    yesterday: "ម្សិលមិញ",
    tomorrow: "ស្អែក",
    thisWeek: "សប្តាហ៍នេះ",
    thisMonth: "ខែនេះ",
    thisYear: "ឆ្នាំនេះ",
    lastWeek: "សប្តាហ៍មុន",
    lastMonth: "ខែមុន",
    lastYear: "ឆ្នាំមុន",

    // Actions
    viewDetails: "មើលព័ត៌មានលម្អិត",
    editItem: "កែប្រែធាតុ",
    deleteItem: "លុបធាតុ",
    addNew: "បន្ថែមថ្មី",
    saveChanges: "រក្សាទុកការផ្លាស់ប្តូរ",
    cancelChanges: "បោះបង់ការផ្លាស់ប្តូរ",
    actions: "សកម្មភាព",
    addProduct: "បន្ថែមផលិតផល",
    remove: "យកចេញ",

    // Salary Bill Sub-modules
    monthlySalary: "ប្រាក់ខែប្រចាំខែ",
    weeklyIncentive: "រង្វាន់ប្រចាំសប្តាហ៍",
    permitFee: "ថ្លៃអនុញ្ញាត",
    resignPayment: "ការបង់ប្រាក់លាឈប់",

    // Gate Pass
    visitor: "អ្នកទស្សនា",
    personalRequest: "សំណើផ្ទាល់ខ្លួន",
    materialTransport: "ការដឹកជញ្ជូនសម្ភារៈ",
    fixedAssetsTransport: "ការដឹកជញ្ជូនទ្រព្យសកម្ម",
    requestReason: "មូលហេតុសំណើ",
    whereToGo: "ទៅកន្លែងណា",
    ymToWh12000: "YM ទៅ WH12000",
    ymToSubFactory: "YM ទៅ Sub Factory",
    ymToOther: "YM ទៅ Other",
    wh12000ToYm: "WH12000 ទៅ YM",
    whToSubFactory: "WH ទៅ Sub Factory",
    whToOther: "WH ទៅ Other",
    departureTime: "ពេលចេញ",
    returnTime: "ពេលត្រឡប់",
    employeeId: "លេខសម្គាល់បុគ្គលិក",
    supervisor: "អ្នកគ្រប់គ្រង",
    supervisorCode: "លេខកូដអ្នកគ្រប់គ្រង",
    addNewVisitor: "បន្ថែមអ្នកទស្សនាថ្មី",
    officeDuty: "កាតព្វកិច្ចការិយាល័យ",
    auditDuty: "កាតព្វកិច្ចសវនកម្ម",
    purchaseGoods: "ទិញទំនិញ",
    repairDevice: "ជួសជុលឧបករណ៍",
    healthIssue: "បញ្ហាសុខាភិបាល",
    personalEmergency: "អាសន្នផ្ទាល់ខ្លួន",
    other: "ផ្សេងៗ",

    // Support Ticket Form
    details: "ព័ត៌មានលម្អិត",
    uploadImage: "ផ្ទុកឡើងរូបភាព",
    writeYourThoughts: "សរសេរមតិរបស់អ្នកនៅទីនេះ...",
    imageSizeWarning: "ជ្រើសទំហំរូបភាពគួរតែតិចជាង",
    imageFormatWarning: "និងគួរតែជា",
    format: "ទ្រង់ទ្រាយ",
    or: "ឬ",

    // Common Form Fields
    employeeName: "ឈ្មោះបុគ្គលិក",
    jobTitle: "តួនាទី",
    position: "មុខងារ",
    joinDate: "កាលបរិច្ឆេទចូល",
    resignDate: "កាលបរិច្ឆេទលាឈប់",
    workingDays: "ថ្ងៃធ្វើការ",
    basicSalary: "ប្រាក់ខែមូលដ្ឋាន",
    allowance: "ឧបត្ថម្ភ",
    deduction: "កាត់",
    netSalary: "ប្រាក់ខែសុទ្ធ",
    paymentDate: "កាលបរិច្ឆេទបង់",
    period: "រយៈពេល",
    from: "ពី",
    to: "ទៅ",
    year: "ឆ្នាំ",
    month: "ខែ",
    week: "សប្តាហ៍",

    // Gate Pass Table Headers
    no: "លេខ",
    employeeIdHeader: "លេខសម្គាល់បុគ្គលិក",
    nameHeader: "ឈ្មោះ",
    departmentHeader: "នាយកដ្ឋាន",
    supervisorHeader: "អ្នកគ្រប់គ្រង",
    requestTypeHeader: "ប្រភេទសំណើ",
    reasonHeader: "មូលហេតុ",
    destination: "គោលដៅ",
    departure: "ចេញ",
    return: "ត្រឡប់",
    approve: "អនុម័ត",
    reject: "បដិសេធ",
    myHistory: "ប្រវត្តិរបស់ខ្ញុំ",
    gpAdmin: "GP-Admin",
    addNewRequest: "បន្ថែមសំណើថ្មី",
    gatePassRequest: "សំណើលិខិតឆ្លងកាត់",
    noPendingRequest: "គ្មានសំណើដែលកំពុងរង់ចាំអនុម័ត",
    allRequestsProcessed: "សំណើទាំងអស់ត្រូវបានដោះស្រាយ",
    employeeInformation: "ព័ត៌មានបុគ្គលិក",
    yourName: "ឈ្មោះរបស់អ្នក",
    authorizedPersonCode: "លេខកូដអ្នកអនុញ្ញាត",
    requestType: "ប្រភេទសំណើ",
    selectRequestType: "--ជ្រើសប្រភេទសំណើ--",
    selectReason: "--ជ្រើសមូលហេតុ--",
    timeSchedule: "កាលវិភាគពេលវេលា",
    submitRequest: "ដាក់ស្នើសំណើ",
    hour: "ម៉ោង",
    minute: "នាទី",

    // Training
    course: "វគ្គសិក្សា",
    lessons: "មេរៀន (PDF)",
    activity: "សកម្មភាព",
    trainingCourse: "វគ្គសិក្សាបណ្តុះបណ្តាល",
    dashboardVideoTraining: "ការបណ្តុះបណ្តាលវីដេអូផ្ទាំងគ្រប់គ្រង",
    list: "បញ្ជី",
    calendar: "ប្រតិទិន",
    trainer: "គ្រូបណ្តុះបណ្តាល",
    category: "ប្រភេទ",
    start: "ចាប់ផ្តើម",
    end: "បញ្ចប់",
    trainingLesson: "មេរៀនបណ្តុះបណ្តាល",
    listAndScheduleTrainingCourse: "បញ្ជី និងកាលវិភាគវគ្គសិក្សាបណ្តុះបណ្តាល",

    // Accountant Module
    checkRequestLists: "បញ្ជីសំណើពិនិត្យ",
    code: "លេខកូដ",
    return: "ត្រឡប់",
    approveStatus: "ស្ថានភាពអនុម័ត",
    invoice: "វិក្កយបត្រ",
    accCheck: "ការពិនិត្យគណនេយ្យ",
    productService: "ផលិតផល/សេវាកម្ម",
    requestDate: "កាលបរិច្ឆេទសំណើ",
    attachDocuments: "ឯកសារភ្ជាប់",
    head: "ប្រធាន",
    purchaser: "អ្នកទិញ",
    checked: "បានពិនិត្យ",
    pending: "កំពុងរង់ចាំ",
    approved: "បានអនុម័ត",
    accPay: "ការបង់គណនេយ្យ",
    accApprove: "ការអនុម័តគណនេយ្យ",
    payRequestLists: "បញ្ជីសំណើបង់",
    approvalRequestLists: "បញ្ជីសំណើអនុម័ត",
    searchByCode: "ស្វែងរកតាមលេខកូដ...",
    newData: "ទិន្នន័យថ្មី",
    oldData: "ទិន្នន័យចាស់",
    requestForm: "ទម្រង់សំណើ",
    pdf: "PDF",
    paid: "បានបង់",
    by: "ដោយ",
    accApprovePay: "ការអនុម័ត និងបង់គណនេយ្យ",

    // Recruitment Form
    positionInformation: "ព័ត៌មានមុខតំណែង",
    positionTitle: "ចំណងជើងមុខតំណែង",
    employmentType: "ប្រភេទការងារ",
    recruitmentSource: "ប្រភពជ្រើសរើស",
    candidateInformation: "ព័ត៌មានបេក្ខជន",
    fullName: "ឈ្មោះពេញ",
    dateOfBirth: "កាលបរិច្ឆេទកំណើត",
    emailAddress: "អាសយដ្ឋានអ៊ីមែល",
    phoneNumber: "លេខទូរស័ព្ទ",
    qualificationsExperience: "ការអប់រំ និងបទពិសោធន៍",
    yearsOfExperience: "ឆ្នាំនៃបទពិសោធន៍",
    skillsCompetencies: "ជំនាញ និងសមត្ថភាព",
    additionalInformation: "ព័ត៌មានបន្ថែម",
    expectedSalary: "ប្រាក់ខែរំពឹងទុក",
    availabilityDate: "កាលបរិច្ឆេទអាចចូលធ្វើការ",
    notesComments: "កំណត់ចំណាំ និងមតិ",
    saveRecruitment: "រក្សាទុកការជ្រើសរើស",
    selectDepartment: "ជ្រើសរើសនាយកដ្ឋាន",
    selectType: "ជ្រើសរើសប្រភេទ",
    selectSource: "ជ្រើសរើសប្រភព",
    selectEducationLevel: "ជ្រើសរើសកម្រិតអប់រំ",
    enterFullName: "បញ្ចូលឈ្មោះពេញ",
    enterAddress: "បញ្ចូលអាសយដ្ឋាន",
    listRelevantSkills: "រាយបញ្ជីជំនាញ និងសមត្ថភាពពាក់ព័ន្ធ",
    additionalNotes: "កំណត់ចំណាំ ឬមតិបន្ថែមអំពីបេក្ខជន",
    fullTime: "ពេញម៉ោង",
    partTime: "ផ្នែកម៉ោង",
    contract: "កិច្ចសន្យា",
    temporary: "បណ្តោះអាសន្ន",
    jobPortal: "វិបផតថលការងារ",
    referral: "ការណែនាំ",
    socialMedia: "បណ្តាញសង្គម",
    recruitmentAgency: "ភ្នាក់ងារជ្រើសរើស",
    walkIn: "ចូលដោយផ្ទាល់",
    highSchool: "វិទ្យាល័យ",
    associateDegree: "សញ្ញាបត្ររួម",
    bachelorsDegree: "សញ្ញាបត្របរិញ្ញាបត្រ",
    mastersDegree: "សញ្ញាបត្រមេ",
    phd: "បណ្ឌិត",
    screening: "ការត្រួតពិនិត្យ",
    shortlisted: "បានជ្រើសរើស",
    rejected: "បានបដិសេធ",
    hired: "បានជួល",

    // Interview Form
    interviewArrangement: "ការរៀបចំសម្ភាសន៍",
    interviewDetails: "ព័ត៌មានលម្អិតសម្ភាសន៍",
    positionApplied: "មុខតំណែងដែលដាក់ពាក្យ",
    interviewDate: "កាលបរិច្ឆេទសម្ភាសន៍",
    interviewTime: "ពេលវេលាសម្ភាសន៍",
    interviewType: "ប្រភេទសម្ភាសន៍",
    locationVenue: "ទីតាំង/កន្លែង",
    primaryInterviewer: "អ្នកសម្ភាសន៍ចម្បង",
    additionalInterviewers: "អ្នកសម្ភាសន៍បន្ថែម",
    interviewEvaluation: "ការវាយតម្លៃសម្ភាសន៍",
    technicalSkills: "ជំនាញបច្ចេកទេស (1-10)",
    communicationSkills: "ជំនាញទំនាក់ទំនង (1-10)",
    culturalFit: "ការសមនឹងវប្បធម៌ (1-10)",
    overallRating: "ការវាយតម្លៃសរុប (1-10)",
    strengths: "ចំណុចខ្លាំង",
    weaknesses: "ចំណុចខ្សោយ",
    recommendation: "ការណែនាំ",
    saveInterview: "រក្សាទុកសម្ភាសន៍",
    enterCandidateName: "បញ្ចូលឈ្មោះបេក្ខជន",
    meetingRoomOrVideoLink: "បន្ទប់ប្រជុំ ឬតំណវីដេអូ",
    interviewerName: "ឈ្មោះអ្នកសម្ភាសន៍",
    commaSeparatedNames: "ឈ្មោះដែលបំបែកដោយក្បៀស",
    phoneScreening: "ការត្រួតពិនិត្យតាមទូរស័ព្ទ",
    videoInterview: "សម្ភាសន៍វីដេអូ",
    inPerson: "ផ្ទាល់ខ្លួន",
    panelInterview: "សម្ភាសន៍ក្រុម",
    technicalInterview: "សម្ភាសន៍បច្ចេកទេស",
    finalInterview: "សម្ភាសន៍ចុងក្រោយ",
    scheduled: "បានកំណត់ពេល",

    // Onboarding Form
    onboarding: "ការដាក់បញ្ចូល",
    employeeInformation: "ព័ត៌មានបុគ្គលិក",
    manager: "អ្នកគ្រប់គ្រង",
    startDate: "កាលបរិច្ឆេទចាប់ផ្តើម",
    workLocation: "ទីតាំងធ្វើការ",
    workSchedule: "កាលវិភាគធ្វើការ",
    orientationDate: "កាលបរិច្ឆេទការណែនាំ",
    orientationCompleted: "ការណែនាំបានបញ្ចប់",
    trainingCompleted: "ការបណ្តុះបណ្តាលបានបញ្ចប់",
    systemAccess: "ការចូលប្រើប្រព័ន្ធ",
    saveOnboarding: "រក្សាទុកការដាក់បញ្ចូល",

    // Temp Worker Request Form
    temporaryWorkerRequest: "សំណើកម្មករបណ្តោះអាសន្ន",
    requestor: "អ្នកស្នើសុំ",
    genderOfWorker: "ភេទកម្មករ",
    shift: "វេន",
    workerType: "ប្រភេទកម្មករ",
    hourlyRate: "អត្រាប្រាក់ឈ្នួលម៉ោង",
    startDate: "កាលបរិច្ឆេទចាប់ផ្តើម",
    endDate: "កាលបរិច្ឆេទបញ្ចប់",
    reason: "មូលហេតុ",
    selectGender: "ជ្រើសរើសភេទ",
    selectOption: "-- ជ្រើសរើស --",
    morningShift: "វេនព្រឹក",
    afternoonShift: "វេនរសៀល",
    nightShift: "វេនយប់",
    fullDay: "ពេញម៉ោង",
    male: "ប្រុស",
    female: "ស្រី",
    other: "ផ្សេងៗ",
    departmentRequired: "នាយកដ្ឋានត្រូវបានទាមទារ",
    genderRequired: "ភេទត្រូវបានទាមទារ",
    shiftRequired: "វេនត្រូវបានទាមទារ",
    workerTypeRequired: "ប្រភេទកម្មករត្រូវបានទាមទារ",
    startDateRequired: "កាលបរិច្ឆេទចាប់ផ្តើមត្រូវបានទាមទារ",
    endDateRequired: "កាលបរិច្ឆេទបញ្ចប់ត្រូវបានទាមទារ",
    reasonRequired: "មូលហេតុត្រូវបានទាមទារ",
    enterReason: "បញ្ចូលមូលហេតុ",
    selectRating: "ជ្រើសរើសការវាយតម្លៃ",
    excellent: "ល្អណាស់",
    good: "ល្អ",
    average: "មធ្យម",
    belowAverage: "ទាបជាងមធ្យម",
    poor: "ខ្សោយ",
    selectRecommendation: "ជ្រើសរើសការណែនាំ",
    strongHire: "ជួលយ៉ាងខ្លាំង",
    hire: "ជួល",
    conditionalHire: "ជួលតាមលក្ខខណ្ឌ",
    doNotHire: "មិនជួល",
    rescheduled: "កំណត់ពេលឡើងវិញ",
    communicationSkills: "ជំនាញទំនាក់ទំនង (1-10)",
    maybe: "ប្រហែល",
    listCandidateStrengths: "រាយបញ្ជីចំណុចខ្លាំងរបស់បេក្ខជន",
    areasForImprovement: "តំបន់សម្រាប់ការកែលម្អ",
    listAreasForImprovement: "រាយបញ្ជីតំបន់សម្រាប់ការកែលម្អ",
    interviewNotes: "កំណត់ចំណាំសម្ភាសន៍",
    detailedInterviewNotes: "កំណត់ចំណាំ និងការសង្កេតសម្ភាសន៍លម្អិត",
    employeeOnboarding: "ការដាក់បញ្ចូលបុគ្គលិក",
    jobDetails: "ព័ត៌មានលម្អិតការងារ",
    reportingManager: "អ្នកគ្រប់គ្រងរាយការណ៍",
    managerName: "ឈ្មោះអ្នកគ្រប់គ្រង",
    jobTitle: "ចំណងជើងការងារ",
    enterFullName: "បញ្ចូលឈ្មោះពេញ",
    employeeAtCompany: "បុគ្គលិក@ក្រុមហ៊ុន.com",
    employeeName: "ឈ្មោះបុគ្គលិក",
    officeLocation: "ទីតាំងការិយាល័យ",
    selectSchedule: "ជ្រើសរើសកាលវិភាគ",
    mondayFriday: "ច័ន្ទ-សុក្រ 8AM-5PM",
    mondaySaturday: "ច័ន្ទ-សៅរ៍ 8AM-5PM",
    shiftWork: "ការងារវេន",
    flexible: "អាចបត់បែន",
    salary: "ប្រាក់ខែ",
    benefits: "ផលប្រយោជន៍",
    equipment: "ឧបករណ៍",
    documents: "ឯកសារ",
    orientation: "ការណែនាំ",
    training: "ការបណ្តុះបណ្តាល",
    systemAccess: "ការចូលប្រើប្រព័ន្ធ",
    saveOnboarding: "រក្សាទុកការដាក់បញ្ចូល",
    completed: "បានបញ្ចប់",
    cancelled: "បានបោះបង់",
    benefitsEquipment: "ផលប្រយោជន៍ និងឧបករណ៍",
    benefitsPackage: "កញ្ចប់ផលប្រយោជន៍",
    equipmentAccess: "ឧបករណ៍ និងការចូលប្រើ",
    documentsChecklist: "ឯកសារ និងបញ្ជី",
    requiredDocuments: "ឯកសារត្រូវការ",
    onboardingChecklist: "បញ្ជីការដាក់បញ្ចូល",
    systemAccessGranted: "ការចូលប្រើប្រព័ន្ធត្រូវបានផ្តល់",
    anyAdditionalNotes: "កំណត់ចំណាំ ឬការណែនាំពិសេសបន្ថែម",
    completeOnboarding: "បញ្ចប់ការដាក់បញ្ចូល",
    healthInsurance: "ការធានារ៉ាប់រងសុខភាព",
    dentalInsurance: "ការធានារ៉ាប់រងធ្មេញ",
    lifeInsurance: "ការធានារ៉ាប់រងជីវិត",
    retirementPlan: "ផែនការចូលនិវត្តន៍",
    paidTimeOff: "ថ្ងៃឈប់សម្រាកដែលបានបង់",
    transportationAllowance: "ឧបត្ថម្ភដឹកជញ្ជូន",
    mealAllowance: "ឧបត្ថម្ភអាហារ",
    laptop: "កុំព្យូទ័រប័រតាបល",
    desktopComputer: "កុំព្យូទ័រធំ",
    mobilePhone: "ទូរស័ព្ទចល័ត",
    emailAccount: "គណនីអ៊ីមែល",
    idCard: "ប័ណ្ណសម្គាល់",
    accessCard: "ប័ណ្ណចូល",
    uniform: "ឯកសណ្ឋាន",
    idCardCopy: "ច្បាប់ចម្លងប័ណ្ណសម្គាល់",
    resumeCv: "ប្រវត្តិរូប/CV",
    educationalCertificates: "វិញ្ញាបនបត្រអប់រំ",
    previousEmploymentLetter: "លិខិតការងារមុន",
    medicalCertificate: "វិញ្ញាបនបត្រវេជ្ជសាស្ត្រ",
    bankAccountDetails: "ព័ត៌មានគណនីធនាគារ",
    emergencyContactForm: "ទម្រង់ទំនាក់ទំនងបន្ទាន់",
    payrollManagement: "ការគ្រប់គ្រងប្រាក់ខែ",
    nssfManagement: "ការគ្រប់គ្រង NSSF",
    visaWorkPermit: "វីសា និងប័ណ្ណការងារ",
    canteenMealManagement: "ការគ្រប់គ្រងអាហារនៅអាហារដ្ឋាន",
    payPeriod: "រយៈពេលបង់",
    payDate: "កាលបរិច្ឆេទបង់",
    earnings: "ប្រាក់ចំណូល",
    basicSalary: "ប្រាក់ខែមូលដ្ឋាន",
    transportationAllowance: "ឧបត្ថម្ភដឹកជញ្ជូន",
    mealAllowance: "ឧបត្ថម្ភអាហារ",
    housingAllowance: "ឧបត្ថម្ភលំនៅដ្ឋាន",
    otherAllowance: "ឧបត្ថម្ភផ្សេងៗ",
    overtime: "ម៉ោងបន្ថែម",
    overtimeHours: "ម៉ោងបន្ថែម",
    overtimeRate: "អត្រាម៉ោងបន្ថែម",
    overtimeAmount: "ចំនួនម៉ោងបន្ថែម",
    deductions: "ការកាត់",
    tax: "ពន្ធ",
    socialSecurity: "សន្តិសុខសង្គម",
    bonuses: "ប្រាក់រង្វាន់",
    performanceBonus: "ប្រាក់រង្វាន់ការអនុវត្ត",
    attendanceBonus: "ប្រាក់រង្វាន់វត្តមាន",
    otherBonus: "ប្រាក់រង្វាន់ផ្សេងៗ",
    netPay: "ប្រាក់សុទ្ធ",
    paymentMethod: "វិធីសាស្ត្របង់",
    bankAccount: "គណនីធនាគារ",
    selectPeriod: "ជ្រើសរើសរយៈពេល",
    monthly: "ប្រចាំខែ",
    biWeekly: "ពីរសប្តាហ៍",
    weekly: "ប្រចាំសប្តាហ៍",
    enrollmentDate: "កាលបរិច្ឆេទចុះឈ្មោះ",
    insuranceProvider: "អ្នកផ្តល់ការធានារ៉ាប់រង",
    policyNumber: "លេខគោលនយោបាយ",
    coverageType: "ប្រភេទការគ្របដណ្តប់",
    selectCoverage: "ជ្រើសរើសការគ្របដណ្តប់",
    individual: "បុគ្គល",
    family: "គ្រួសារ",
    employeeSpouse: "បុគ្គលិក + ប្តី/ប្រពន្ធ",
    employeeChildren: "បុគ្គលិក + កូន",
    nationality: "សញ្ជាតិ",
    passportNumber: "លេខលិខិតឆ្លងដែន",
    passportIssueDate: "កាលបរិច្ឆេទចេញលិខិតឆ្លងដែន",
    passportExpiryDate: "កាលបរិច្ឆេទផុតកំណត់លិខិតឆ្លងដែន",
    visaType: "ប្រភេទវីសា",
    visaNumber: "លេខវីសា",
    visaIssueDate: "កាលបរិច្ឆេទចេញវីសា",
    visaExpiryDate: "កាលបរិច្ឆេទផុតកំណត់វីសា",
    workPermitNumber: "លេខប័ណ្ណការងារ",
    workPermitIssueDate: "កាលបរិច្ឆេទចេញប័ណ្ណការងារ",
    workPermitExpiryDate: "កាលបរិច្ឆេទផុតកំណត់ប័ណ្ណការងារ",
    renewalRequired: "ត្រូវការបន្ត",
    renewalDate: "កាលបរិច្ឆេទបន្ត",
    active: "សកម្ម",
    expired: "ផុតកំណត់",
    mealDate: "កាលបរិច្ឆេទអាហារ",
    mealType: "ប្រភេទអាហារ",
    selectMealType: "ជ្រើសរើសប្រភេទអាហារ",
    breakfast: "អាហារពេលព្រឹក",
    lunch: "អាហារថ្ងៃត្រង់",
    dinner: "អាហារពេលល្ងាច",
    mealOption: "ជម្រើសអាហារ",
    quantity: "បរិមាណ",
    unitPrice: "តម្លៃឯកតា",
    totalAmount: "ចំនួនសរុប",
    specialRequests: "សំណើពិសេស",
    dietaryRestrictions: "ការរឹតបន្តឹងអាហារ",
    dietaryRestrictionsPreferences: "ការរឹតបន្តឹង និងចំណូលចិត្តអាហារ",
    paymentStatus: "ការបង់ និងស្ថានភាព",
    selectPaymentMethod: "ជ្រើសរើសវិធីសាស្ត្របង់",
    cash: "សាច់ប្រាក់",
    card: "កាត",
    mobilePayment: "ការបង់តាមទូរស័ព្ទ",
    nssfMemberNumber: "លេខសមាជិក NSSF",
    registrationDate: "កាលបរិច្ឆេទចុះឈ្មោះ",
    contributionPeriod: "រយៈពេលការរួមចំណែក",
    salaryBase: "មូលដ្ឋានប្រាក់ខែ",
    employeeContribution: "ការរួមចំណែកបុគ្គលិក",
    employerContribution: "ការរួមចំណែកនិយោជិត",
    totalContribution: "ការរួមចំណែកសរុប",
    contributionRate: "អត្រាការរួមចំណែក",
    lastPaymentDate: "កាលបរិច្ឆេទបង់ចុងក្រោយ",
    nextPaymentDate: "កាលបរិច្ឆេទបង់បន្ទាប់",
    current: "បច្ចុប្បន្ន",
    overdue: "យឺត",
    saveBenefitProfile: "រក្សាទុកប្រវត្តិផលប្រយោជន៍",
    savePayroll: "រក្សាទុកប្រាក់ខែ",
    saveNSSF: "រក្សាទុក NSSF",
    saveVisaWorkPermit: "រក្សាទុកវីសា និងប័ណ្ណការងារ",
    saveCanteen: "រក្សាទុកការបញ្ជាទិញអាហារដ្ឋាន",
    perHour: "ក្នុងមួយម៉ោង",
    netPayPaymentDetails: "ប្រាក់សុទ្ធ និងព័ត៌មានលម្អិតការបង់",
    bankTransfer: "ការផ្ទេរតាមធនាគារ",
    check: "ឆែក",
    bankAccountNumber: "លេខគណនីធនាគារ",
    bankAccountNumberPlaceholder: "លេខគណនីធនាគារ",
    anyAdditionalNotesPayroll: "កំណត់ចំណាំបន្ថែមអំពីប្រាក់ខែ",
    processPayroll: "ដំណើរការប្រាក់ខែ",
    departmentName: "ឈ្មោះនាយកដ្ឋាន",
    otherDeduction: "ការកាត់ផ្សេងៗ",
    policyNumberPlaceholder: "លេខគោលនយោបាយ",
    insuranceCompany: "ក្រុមហ៊ុនធានារ៉ាប់រង",
    insuranceCompanyName: "ឈ្មោះក្រុមហ៊ុនធានារ៉ាប់រង",
    provider: "អ្នកផ្តល់",
    dentalInsuranceCovered: "បានគ្របដណ្តប់ការធានារ៉ាប់រងធ្មេញ",
    lifeInsuranceCovered: "បានគ្របដណ្តប់ការធានារ៉ាប់រងជីវិត",
    coverageAmount: "ចំនួនការគ្របដណ្តប់",
    beneficiary: "អ្នកទទួលផល",
    beneficiaryName: "ឈ្មោះអ្នកទទួលផល",
    retirementPlan: "ផែនការចូលនិវត្តន៍",
    enrolledInRetirementPlan: "បានចុះឈ្មោះផែនការចូលនិវត្តន៍",
    planType: "ប្រភេទផែនការ",
    selectPlan: "ជ្រើសរើសផែនការ",
    employeeContributionRate: "អត្រាការរួមចំណែកបុគ្គលិក (%)",
    employerMatch: "ការផ្គូផ្គងនិយោជិត (%)",
    accountNumber: "លេខគណនី",
    accountNumberPlaceholder: "លេខគណនី",
    paidTimeOff: "ថ្ងៃឈប់សម្រាកដែលបានបង់",
    totalDaysAllocated: "ចំនួនថ្ងៃសរុបដែលបានបែងចែក",
    daysUsed: "ថ្ងៃបានប្រើ",
    remainingDays: "ថ្ងៃនៅសល់",
    carryOverDays: "ថ្ងៃអាចផ្ទេរទៅ",
    allowances: "ឧបត្ថម្ភ",
    otherAllowances: "ឧបត្ថម្ភផ្សេងៗ",
    anyAdditionalNotesBenefits: "កំណត់ចំណាំបន្ថែមអំពីផលប្រយោជន៍",
    passportInformation: "ព័ត៌មានលិខិតឆ្លងដែន",
    issueDate: "កាលបរិច្ឆេទចេញ",
    expiryDate: "កាលបរិច្ឆេទផុតកំណត់",
    expired: "ផុតកំណត់",
    expiringSoon: "នឹងផុតកំណត់ឆាប់ៗ",
    visaInformation: "ព័ត៌មានវីសា",
    selectVisaType: "ជ្រើសរើសប្រភេទវីសា",
    businessVisa: "វីសាអាជីវកម្ម",
    workVisa: "វីសាការងារ",
    touristVisa: "វីសាទេសចរណ៍",
    diplomaticVisa: "វីសាទូត",
    studentVisa: "វីសាសិស្ស",
    visaNumberPlaceholder: "លេខវីសា",
    workPermitInformation: "ព័ត៌មានប័ណ្ណការងារ",
    workPermitNumberPlaceholder: "លេខប័ណ្ណការងារ",
    documentsChecklist: "បញ្ជីឯកសារ",
    passportCopy: "ច្បាប់ចម្លងលិខិតឆ្លងដែន",
    visaCopy: "ច្បាប់ចម្លងវីសា",
    workPermitCopy: "ច្បាប់ចម្លងប័ណ្ណការងារ",
    employmentContract: "កិច្ចសន្យាការងារ",
    policeClearance: "លិខិតបញ្ជាក់ពីប៉ូលីស",
    previousWorkPermits: "ប័ណ្ណការងារមុន",
    anyAdditionalNotesVisa: "កំណត់ចំណាំបន្ថែមអំពីវីសា និងប័ណ្ណការងារ",
    mealDetails: "ព័ត៌មានលម្អិតអាហារ",
    selectMeal: "ជ្រើសរើសអាហារ",
    confirmed: "បានបញ្ជាក់",
    prepared: "បានរៀបចំ",
    collected: "បានប្រមូល",
    anySpecialRequests: "សំណើពិសេស ឬការណែនាំសម្រាប់អាហារ",
    anyAdditionalNotesMeal: "កំណត់ចំណាំបន្ថែមអំពីការបញ្ជាទិញអាហារ",
    nssfRegistration: "ការចុះឈ្មោះ NSSF",
    status: "ស្ថានភាព",
    active: "សកម្ម",
    suspended: "បានផ្អាក",
    terminated: "បានបញ្ចប់",
    quarterly: "ប្រចាំត្រីមាស",
    annually: "ប្រចាំឆ្នាំ",
    contributionDetails: "ព័ត៌មានលម្អិតការរួមចំណែក",
    contributionRatePercent: "អត្រាការរួមចំណែក (%)",
    nssfBenefits: "ផលប្រយោជន៍ NSSF",
    eligibleForDisability: "មានសិទ្ធិទទួលផលប្រយោជន៍ពិការ",
    eligibleForDeath: "មានសិទ្ធិទទួលផលប្រយោជន៍ស្លាប់",
    beneficiaryNamePlaceholder: "ឈ្មោះអ្នកទទួលផល",
    coverageAmountPlaceholder: "0.00",
    nssfDocumentsChecklist: "បញ្ជីឯកសារ",
    nssfRegistrationForm: "ទម្រង់ចុះឈ្មោះ NSSF",
    idCardCopyNssf: "ច្បាប់ចម្លងប័ណ្ណសម្គាល់",
    employmentLetter: "លិខិតការងារ",
    bankStatement: "ប្រតិទិនធនាគារ",
    anyAdditionalNotesNssf: "កំណត់ចំណាំបន្ថែមអំពី NSSF",
    pensionPlan: "ផែនការប្រាក់ប័ណ្ណ",
    providentFund: "មូលនិធិផ្តល់",
    other: "ផ្សេងៗ",
    beneficiaryNamePlaceholder: "ឈ្មោះអ្នកទទួលផល",
    vegetarian: "អ្នកបរិភោគរុក្ខជាតិ",
    vegan: "អ្នកបរិភោគរុក្ខជាតិសុទ្ធ",
    halal: "ហាឡាល់",
    noPork: "មិនមានសាច់ជ្រូក",
    noBeef: "មិនមានសាច់គោ",
    noSeafood: "មិនមានអាហារសមុទ្រ",
    glutenFree: "គ្មានគ្លុយតេន",
    lowSalt: "អំបិលតិច",
    noSpicy: "មិនមានហិរ",
    diabeticFriendly: "សមរម្យសម្រាប់ជំងឺទឹកនោមផ្អែម",
    mealCard: "កាតអាហារ",
    monthlyDeduction: "ការកាត់ប្រចាំខែ",
    companySubsidy: "ការឧបត្ថម្ភក្រុមហ៊ុន",
    placeOrder: "ដាក់ការបញ្ជាទិញ",
    passportNumberPlaceholder: "លេខលិខិតឆ្លងដែន",
    workPermitNumberPlaceholder: "លេខប័ណ្ណការងារ",
    renewalInformation: "ព័ត៌មានការបន្ត",
    renewed: "បានបន្ត",
    paymentStatus: "ស្ថានភាពការបង់",
    paid: "បានបង់",
    medicalBenefits: "ផលប្រយោជន៍វេជ្ជសាស្ត្រ",
    eligibleForMedicalBenefits: "មានសិទ្ធិទទួលផលប្រយោជន៍វេជ្ជសាស្ត្រ",
    coverageStartDate: "កាលបរិច្ឆេទចាប់ផ្តើមការគ្របដណ្តប់",
    coverageEndDate: "កាលបរិច្ឆេទបញ្ចប់ការគ្របដណ្តប់",
    retirementBenefits: "ផលប្រយោជន៍ចូលនិវត្តន៍",
    eligibleForRetirementBenefits: "មានសិទ្ធិទទួលផលប្រយោជន៍ចូលនិវត្តន៍",
    accountBalance: "សមតុល្យគណនី",
    projectedRetirementDate: "កាលបរិច្ឆេទចូលនិវត្តន៍ដែលគ្រោងទុក",
    estimatedMonthlyBenefit: "ផលប្រយោជន៍ប្រចាំខែប៉ាន់ស្មាន",
    disabilityBenefits: "ផលប្រយោជន៍ពិការ",
    deathBenefits: "ផលប្រយោជន៍ស្លាប់",
    nationalityPlaceholder: "ឧ. ខ្មែរ, ថៃ, វៀតណាម",
    passportIssueDate: "កាលបរិច្ឆេទចេញ",
    passportExpiryDate: "កាលបរិច្ឆេទផុតកំណត់",
    workPermitIssueDate: "កាលបរិច្ឆេទចេញ",
    workPermitExpiryDate: "កាលបរិច្ឆេទផុតកំណត់",
    passportCopy: "ច្បាប់ចម្លងលិខិតឆ្លងដែន",
    visaCopy: "ច្បាប់ចម្លងវីសា",
    workPermitCopy: "ច្បាប់ចម្លងប័ណ្ណការងារ",
    employmentContract: "កិច្ចសន្យាការងារ",
    medicalCertificate: "វិញ្ញាបនបត្រវេជ្ជសាស្ត្រ",
    policeClearance: "លិខិតបញ្ជាក់ពីប៉ូលីស",
    educationalCertificates: "វិញ្ញាបនបត្រអប់រំ",
    previousWorkPermits: "ប័ណ្ណការងារមុន",
    nssfRegistrationForm: "ទម្រង់ចុះឈ្មោះ NSSF",
    idCardCopyNssf: "ច្បាប់ចម្លងប័ណ្ណសម្គាល់",
    salaryCertificate: "វិញ្ញាបនបត្រប្រាក់ខែ",
    bankAccountDetails: "ព័ត៌មានគណនីធនាគារ",
    beneficiaryForm: "ទម្រង់អ្នកទទួលផល",
    previousNssfRecords: "កំណត់ត្រា NSSF មុន",
    saveNssfInformation: "រក្សាទុកព័ត៌មាន NSSF",
    anyAdditionalNotesNssfRegistration: "កំណត់ចំណាំបន្ថែមអំពីការចុះឈ្មោះ និងផលប្រយោជន៍ NSSF",
    meetingRoomBooking: "កក់បន្ទប់ប្រជុំ",
    newBooking: "កក់ថ្មី",
    myHistory: "ប្រវត្តិរបស់ខ្ញុំ",
    allBooking: "ការកក់ទាំងអស់",
    totalMeetings: "ការប្រជុំសរុប",
    ongoing: "កំពុងដំណើរការ",
    upcoming: "នឹងមកដល់",
    today: "ថ្ងៃនេះ",
    filterByStatus: "ត្រង់តាមស្ថានភាព",
    showing: "បង្ហាញ",
    meetings: "ការប្រជុំ",
    meetingInfo: "ព័ត៌មានការប្រជុំ",
    organizer: "អ្នករៀបចំ",
    schedule: "កាលវិភាគ",
    participants: "អ្នកចូលរួម",
    meetingLink: "តំណការប្រជុំ",
    join: "ចូលរួម",
    view: "មើល",
    meetingRoomBookingForm: "ទម្រង់កក់បន្ទប់ប្រជុំ",
    yourName: "ឈ្មោះរបស់អ្នក",
    meetingType: "ប្រភេទការប្រជុំ",
    selectMeetingType: "--ជ្រើសប្រភេទការប្រជុំ--",
    teamMeeting: "ការប្រជុំក្រុម",
    clientPresentation: "ការបង្ហាញអតិថិជន",
    trainingSession: "សម័យបណ្តុះបណ្តាល",
    projectReview: "ការពិនិត្យគម្រោង",
    mentionPersonOptional: "រៀបរាប់អ្នក (ជម្រើស)",
    searchByEmployeeName: "ស្វែងរកតាមឈ្មោះបុគ្គលិក",
    meetingDate: "កាលបរិច្ឆេទការប្រជុំ",
    startTime: "ពេលវេលាចាប់ផ្តើម",
    endTime: "ពេលវេលាបញ្ចប់",
    meetingLinkOptional: "តំណការប្រជុំ (ជម្រើស)",
    remove: "លុប",
    addMeetingLink: "បន្ថែមតំណការប្រជុំ",
    enterMeetingLink: "បញ្ចូលតំណការប្រជុំ:",
    selectMeetingRoom: "ជ្រើសបន្ទប់ប្រជុំ",
    selected: "បានជ្រើស",
    book: "កក់",
    total: "សរុប",
    request: "សំណើ",
    approved: "បានអនុម័ត",
    cancelled: "បានលុបចោល",
    bookingForOldPeople: "កក់សម្រាប់អ្នកចាស់",
    no: "លេខ",
    dateTime: "កាលបរិច្ឆេទ/ពេលវេលា",
    numberOfPeople: "ចំនួនមនុស្ស",
    destination: "ទីតាំងគោលដៅ",
    driver: "អ្នកបើកបរ",
    driverStatus: "ស្ថានភាពអ្នកបើកបរ",
    inProgress: "កំពុងដំណើរការ",
    noDriverAssignedYet: "មិនទាន់មានអ្នកបើកបរនៅឡើយ",
    share: "ចែករំលែក",
    planYourRoute: "រៀបចំផ្លូវរបស់អ្នកដោយប្រើផែនទី",
    yourInformation: "ព័ត៌មានរបស់អ្នក",
    selectUserBooking: "ជ្រើសអ្នកប្រើប្រាស់កក់",
    user: "អ្នកប្រើប្រាស់",
    code: "លេខកូដ:",
    routePlanning: "ការរៀបចំផ្លូវ",
    map: "ផែនទី",
    satellite: "ផ្កាយរណប",
    gps: "GPS:",
    min: "នាទី:",
    clearRoute: "លុបផ្លូវ",
    centerMap: "កណ្តាលផែនទី",
    showSelected: "បង្ហាញដែលបានជ្រើស",
    showCar: "បង្ហាញរថយន្ត",
    interactiveMapDisplayed: "ផែនទីអន្តរកម្មនឹងត្រូវបានបង្ហាញនៅទីនេះ",
    phnomPenhArea: "តំបន់ភ្នំពេញជាមួយកណ្តុរទីតាំង",
    visitorLog: "កំណត់ត្រាអ្នកទស្សនា",
    printRecords: "បោះពុម្ពកំណត់ត្រា",
    noVisitorRecordsFound: "មិនបានរកឃើញកំណត់ត្រាអ្នកទស្សនាទេ។",
    visitorLogNewEntry: "កំណត់ត្រាអ្នកទស្សនា - ធាតុថ្មី",
    visitorsName: "ឈ្មោះអ្នកទស្សនា",
    idCardNo: "លេខអត្តសញ្ញាណប័ណ្ណ",
    contactPerson: "អ្នកទំនាក់ទំនង",
    purposeOfVisiting: "គោលបំណងនៃការទស្សនា",
    visitorCardNo: "លេខកាតអ្នកទស្សនា",
    carCheck: "ការត្រួតពិនិត្យរថយន្ត",
    companyName: "ឈ្មោះក្រុមហ៊ុន",
    phoneNumber: "លេខទូរស័ព្ទ",
    timeIn: "ពេលចូល",
    carMotorPlate: "លេខផ្លាករថយន្ត/ម៉ូតូ",
    logVisitor: "កត់ត្រាអ្នកទស្សនា",
    checkOut: "ពិនិត្យចេញ",
    car: "រថយន្ត",
    truck: "រថយន្តដឹកទំនិញ",
    qSearchPickUp: "Q ស្វែងរកកន្លែងយក",
    checklistAttendance: "បញ្ជីពិនិត្យវត្តមាន",
    myAttendance: "វត្តមានរបស់ខ្ញុំ",
    sectionName: "ឈ្មោះផ្នែក",
    fromDate: "ពីកាលបរិច្ឆេទ",
    toDate: "ដល់កាលបរិច្ឆេទ",
    employeeName: "ឈ្មោះបុគ្គលិក",
    attendance: "វត្តមាន",
    present: "មាន",
    absent: "អវត្តមាន",
    special: "ពិសេស",
    searchEmployee: "ស្វែងរកបុគ្គលិក",
    filter: "ត្រង់",
    attendanceCodes: "លេខកូដវត្តមាន",
    comeToWork: "មកធ្វើការ",
    leaveWithPermission: "ឈប់មានច្បាប់",
    absentWithoutPermission: "ឈប់អត់ច្បាប់",
    sickLeaveOrMaternity: "ច្បាប់ឈើ ឬពិនិត្យផ្ទៃពោះ",
    specialLeave: "ច្បាប់ពិសេស",
    annualLeave: "ច្បាប់បំណាច់ឆ្នាំ",
    resigned: "លាឈប់",
    suspendedLeave: "ច្បាប់ព្យួរ",
    maternityLeave: "ច្បាប់សម្រាល",
    overtime: "ថែមម៉ោង",
    workOnHoliday: "ធ្វើការថ្ងៃឈប់សម្រាក",
    visitorIdNumber: "លេខអត្តសញ្ញាណអ្នកទស្សនា",
    timeOut: "ពេលចេញ",
    photos: "រូបភាព",
    previous: "មុន",
    next: "បន្ទាប់",
    searchByIDOrName: "ស្វែងរកតាមលេខសម្គាល់ ឬឈ្មោះ...",
    from: "ពី",
    to: "ដល់",
    photo: "រូបភាព",
    name: "ឈ្មោះ",
    sex: "ភេទ",
    time: "ពេលវេលា",
    morning: "ព្រឹក",
    evening: "ល្ងាច",
    showAttendance: "បង្ហាញវត្តមាន",
    texlinkTechnologies: "TEXLINK TECHNOLOGIES CO., LTD.",
    dailyAttendanceList: "បញ្ជីស្រង់វត្តមានប្រចាំថ្ងៃ",
    of: "នៃ",
    results: "លទ្ធផល",
    systemAnalyticsDashboard: "ផ្ទាំងគ្រប់គ្រងការវិភាគប្រព័ន្ធ",
    realtimeInsightsAndPerformanceMetrics: "ការយល់ដឹងពេលវេលាពិត និងការវាស់វែងការអនុវត្ត",
    activePeriod: "រយៈពេលសកម្ម",
    totalSystemRequests: "សំណើប្រព័ន្ធសរុប",
    networkActivityTracked: "សកម្មភាពបណ្តាញត្រូវបានតាមដាន",
    uniqueActiveUsers: "អ្នកប្រើប្រាស់សកម្មតែមួយ",
    engagementMonitored: "ការចូលរួមត្រូវបានតាមដាន",
    yesterday: "ម្សិលមិញ",
    last7Days: "៧ ថ្ងៃចុងក្រោយ",
    last30Days: "៣០ ថ្ងៃចុងក្រោយ",
    thisMonth: "ខែនេះ",
    lastMonth: "ខែមុន",
    startDate: "កាលបរិច្ឆេទចាប់ផ្តើម",
    endDate: "កាលបរិច្ឆេទបញ្ចប់",
    applyFilter: "អនុវត្តត្រង់",
    exportReport: "នាំចេញរបាយការណ៍",
    realtimeAnalyticsDashboard: "ផ្ទាំងគ្រប់គ្រងការវិភាគពេលវេលាពិត",
    moduleRequests: "សំណើម៉ូឌុល",
    userDistribution: "ការចែកចាយអ្នកប្រើប្រាស់",
    systemOverview: "ទិដ្ឋភាពទូទៅនៃប្រព័ន្ធ",
    module: "ម៉ូឌុល",
    totalRequests: "សំណើសរុប",
    uniqueUsers: "អ្នកប្រើប្រាស់តែមួយ",
    metersDeviceList: "បញ្ជីឧបករណ៍ម៉ែត្រ",
    deviceId: "លេខសម្គាល់ឧបករណ៍",
    location: "ទីតាំង",
    lastReading: "ការអានចុងក្រោយ",
    energyUsage: "ការប្រើប្រាស់ថាមពល",
    online: "អនឡាញ",
    offline: "អន្តរអន្តរនេត",
    returnMessage: "សារត្រឡប់",
    viewReturnDetails: "មើលព័ត៌មានលម្អិតត្រឡប់",
    detail: "ព័ត៌មានលម្អិត",
    pdf: "PDF",
    requestForm: "ទម្រង់សំណើ",
    monthlySalary: "ប្រាក់បៀវត្សរ៍ប្រចាំខែ",
    payDate: "កាលបរិច្ឆេទបង់ប្រាក់",
    earnings: "ប្រាក់ចំណូល",
    communicationAllowance: "ឧបត្ថម្ភទំនាក់ទំនង",
    overtimeHours: "ម៉ោងធ្វើការបន្ថែម",
    overtimeRatePerHour: "អត្រាធ្វើការបន្ថែម (ក្នុងមួយម៉ោង)",
    performanceBonus: "ប្រាក់រង្វាន់ការអនុវត្ត",
    attendanceBonus: "ប្រាក់រង្វាន់វត្តមាន",
    productionBonus: "ប្រាក់រង្វាន់ផលិតកម្ម",
    tax: "ពន្ធ",
    nssfContribution: "ការរួមចំណែក NSSF",
    salaryAdvance: "ប្រាក់បៀវត្សរ៍ទុនបម្រុង",
    loanDeduction: "ការកាត់ប្រាក់កម្ចី",
    salarySummary: "សង្ខេបប្រាក់បៀវត្សរ៍",
    grossSalary: "ប្រាក់បៀវត្សរ៍សរុប",
    paymentDetails: "ព័ត៌មានលម្អិតការបង់ប្រាក់",
    selectMethod: "ជ្រើសវិធី",
    bankTransfer: "ការផ្ទេរប្រាក់តាមធនាគារ",
    cash: "សាច់ប្រាក់",
    check: "ឆែក",
    mobilePayment: "ការបង់ប្រាក់តាមទូរស័ព្ទ",
    bankAccountNumberPlaceholder: "លេខគណនីធនាគារ",
    processed: "បានដំណើរការ",
    additionalNotesAboutSalaryPayment: "កំណត់ចំណាំបន្ថែមអំពីការបង់ប្រាក់បៀវត្សរ៍",
    processMonthlySalary: "ដំណើរការប្រាក់បៀវត្សរ៍ប្រចាំខែ",
    selectMonth: "ជ្រើសខែ",
    january: "មករា",
    february: "កុម្ភៈ",
    march: "មីនា",
    april: "មេសា",
    may: "ឧសភា",
    june: "មិថុនា",
    july: "កក្កដា",
    august: "សីហា",
    september: "កញ្ញា",
    october: "តុលា",
    november: "វិច្ឆិកា",
    december: "ធ្នូ",
    departmentName: "ឈ្មោះនាយកដ្ឋាន",
    jobTitle: "តួនាទីការងារ",
    shopManagement: "ការគ្រប់គ្រងហាង",
    ticketManagement: "ការគ្រប់គ្រងសំបុត្រ",
    masterList: "បញ្ជីមេ",
    oldData: "ទិន្នន័យចាស់",
    newData: "ទិន្នន័យថ្មី",
    myRequest: "សំណើរបស់ខ្ញុំ",
    requester: "អ្នកស្នើ",
    head: "ប្រធាន",
    gm: "GM",
    purchaser: "អ្នកទិញ",
    accountant: "គណនេយ្យករ",
    topic: "ប្រធានបទ",
    progress: "វឌ្ឍនភាព",
    noRequestsFound: "មិនបានរកឃើញសំណើ",
    confirmReceivedProductService: "បញ្ជាក់ការទទួលផលិតផល/សេវា",
    confirmReceivedProductServiceList: "បញ្ជីបញ្ជាក់ការទទួលផលិតផល/សេវា",
    myReceived: "អ្វីដែលខ្ញុំបានទទួល",
    requestedBy: "ស្នើដោយ",
    requestDate: "កាលបរិច្ឆេទសំណើ",
    received: "បានទទួល",
    confirmed: "បានបញ្ជាក់",
    noApprovedRequestsFound: "មិនបានរកឃើញសំណើដែលបានអនុម័ត",
    weeklyIncentive: "ប្រាក់រង្វាន់ប្រចាំសប្តាហ៍",
    permitFee: "ថ្លៃសិទ្ធិ",
    resignPayment: "ការបង់ប្រាក់លាឈប់",
    weekInformation: "ព័ត៌មានសប្តាហ៍",
    weekStartDate: "កាលបរិច្ឆេទចាប់ផ្តើមសប្តាហ៍",
    weekEndDate: "កាលបរិច្ឆេទបញ្ចប់សប្តាហ៍",
    incentiveType: "ប្រភេទប្រាក់រង្វាន់",
    selectType: "ជ្រើសប្រភេទ",
    performance: "ការអនុវត្ត",
    production: "ផលិតកម្ម",
    quality: "គុណភាព",
    team: "ក្រុម",
    combined: "រួមបញ្ចូល",
    incentiveDetails: "ព័ត៌មានលម្អិតប្រាក់រង្វាន់",
    baseAmount: "ចំនួនមូលដ្ឋាន",
    performanceMultiplier: "មេគុណការអនុវត្ត",
    qualityBonus: "ប្រាក់រង្វាន់គុណភាព",
    teamBonus: "ប្រាក់រង្វាន់ក្រុម",
    totalIncentive: "ប្រាក់រង្វាន់សរុប",
    multiplierForBaseAmount: "មេគុណសម្រាប់ចំនួនមូលដ្ឋាន (ឧ. 1.0 = 100%, 1.5 = 150%)",
    permitInformation: "ព័ត៌មានសិទ្ធិ",
    selectPermitType: "ជ្រើសប្រភេទសិទ្ធិ",
    workPermit: "សិទ្ធិធ្វើការ",
    visa: "វីសា",
    residencePermit: "សិទ្ធិរស់នៅ",
    businessPermit: "សិទ្ធិអាជីវកម្ម",
    professionalLicense: "អាជ្ញាប័ណ្ណវិជ្ជាជីវៈ",
    permitNumber: "លេខសិទ្ធិ",
    permitNumberPlaceholder: "លេខសិទ្ធិ",
    issueDate: "កាលបរិច្ឆេទចេញ",
    expiryDate: "កាលបរិច្ឆេទផុតកំណត់",
    feeDetails: "ព័ត៌មានលម្អិតថ្លៃ",
    permitFeeAmount: "ចំនួនថ្លៃសិទ្ធិ",
    processingFee: "ថ្លៃដំណើរការ",
    renewalFee: "ថ្លៃបន្ត",
    lateFee: "ថ្លៃពន្យារ",
    lateFeeIfApplicable: "ថ្លៃពន្យារ (ប្រសិនបើមាន)",
    totalFee: "ថ្លៃសរុប",
    paymentDate: "កាលបរិច្ឆេទបង់ប្រាក់",
    receiptNumber: "លេខបង្កាន់ដៃ",
    receiptNumberPlaceholder: "លេខបង្កាន់ដៃ",
    processPermitFee: "ដំណើរការថ្លៃសិទ្ធិ",
    resignationDate: "កាលបរិច្ឆេទលាឈប់",
    lastWorkingDate: "កាលបរិច្ឆេទធ្វើការចុងក្រោយ",
    finalSalary: "ប្រាក់បៀវត្សរ៍ចុងក្រោយ",
    proratedDays: "ថ្ងៃសមាមាត្រ",
    proratedAmount: "ចំនួនសមាមាត្រ",
    unusedLeave: "ច្បាប់មិនបានប្រើ",
    totalDays: "ថ្ងៃសរុប",
    paidDays: "ថ្ងៃបង់ប្រាក់",
    severancePay: "ប្រាក់បំបែក",
    noticePeriodPay: "ប្រាក់ប្រកាស",
    totalEarnings: "ប្រាក់ចំណូលសរុប",
    netPayment: "ការបង់ប្រាក់សុទ្ធ",
    clearanceStatus: "ស្ថានភាពការសម្អាត",
    processResignPayment: "ដំណើរការការបង់ប្រាក់លាឈប់",
    processWeeklyIncentive: "ដំណើរការប្រាក់រង្វាន់ប្រចាំសប្តាហ៍",
    additionalNotesAboutWeeklyIncentive: "កំណត់ចំណាំបន្ថែមអំពីប្រាក់រង្វាន់ប្រចាំសប្តាហ៍",
    companyPaid: "ក្រុមហ៊ុនបង់",
    reimbursed: "បានសងប្រាក់",
    cancelled: "បានលុបចោល",
    unusedLeavePayment: "ការបង់ប្រាក់ច្បាប់មិនបានប្រើ",
    totalUnusedLeaveDays: "ថ្ងៃច្បាប់មិនបានប្រើសរុប",
    leavePaymentAmount: "ចំនួនប្រាក់បង់ច្បាប់",
    additionalPayments: "ការបង់ប្រាក់បន្ថែម",
    equipment: "ឧបករណ៍",
    additionalNotesAboutPermitFeePayment: "កំណត់ចំណាំបន្ថែមអំពីការបង់ប្រាក់ថ្លៃសិទ្ធិ",
    outstandingLoan: "កម្ចីដែលនៅសល់",
    equipmentAssetRecovery: "ការទាញយកឧបករណ៍/ទ្រព្យសម្បត្តិ",
    paymentSummary: "សង្ខេបការបង់ប្រាក់",
    paymentStatus: "ស្ថានភាពការបង់ប្រាក់",
    additionalNotesAboutResignationPayment: "កំណត់ចំណាំបន្ថែមអំពីការបង់ប្រាក់លាឈប់",
    scheduledTicket: "សំបុត្រដែលបានកំណត់ពេល",
    list: "បញ្ជី",
    kpi: "KPI",
    ticketsOverview: "ទិដ្ឋភាពទូទៅនៃសំបុត្រ",
    assign: "ចាត់តាំង",
    requested: "បានស្នើ",
    scheduled: "បានកំណត់ពេល",
    gaMainTeamProgress: "វឌ្ឍនភាពក្រុម GA Main",
    toDo: "ត្រូវធ្វើ",
    planned: "បានរៀបចំ",
    done: "បានធ្វើ",
    myTickets: "សំបុត្ររបស់ខ្ញុំ",
    timeline: "បន្ទាត់ពេលវេលា",
    feedback: "មតិយោបល់",
    enterYourFeedback: "បញ្ចូលមតិយោបល់របស់អ្នក...",
    submit: "ដាក់ស្នើ",
    myCarBookings: "ការកក់រថយន្តរបស់ខ្ញុំ",
    id: "លេខសម្គាល់",
    destination: "គោលដៅ",
    newBooking: "ការកក់ថ្មី",
    dataList: "បញ្ជីទិន្នន័យ",
    value: "តម្លៃ",
    noDataAvailable: "មិនមានទិន្នន័យ",
    active: "សកម្ម",
    meetingRoomBooking: "ការកក់បន្ទប់ប្រជុំ",
    roomALarge: "បន្ទប់ A (ធំ)",
    roomBSmall: "បន្ទប់ B (តូច)",
    confHall: "សាលប្រជុំ",
    projectRoom: "បន្ទប់គម្រោង",
    teamSync: "ការសម្របសម្រួលក្រុម",
    clientCall: "ការហៅអតិថិជន",
    trainingCourses: "វគ្គបណ្តុះបណ្តាល",
    orientation: "ការណែនាំ",
    safety: "សុវត្ថិភាព",
    compliance: "ការអនុវត្ត",
    technical: "បច្ចេកទេស",
    softSkills: "ជំនាញទន់",
    leadership: "ការដឹកនាំ",
    itSecurity: "សុវត្ថិភាព IT",
    firstAid: "ជំនាញជំងឺ",
    qualityControl: "ការគ្រប់គ្រងគុណភាព",
    inventory: "ស្តុក",
    customerService: "សេវាកម្មអតិថិជន",
    management: "ការគ្រប់គ្រង",
    masterOrganizationChart: "តារាងអង្គភាពមេ",
    zoomOut: "បង្រួម",
    zoomIn: "ពង្រីក",
    resetView: "កំណត់ឡើងវិញ",
    tip: "ព័ត៌មាន",
    clickAndDragToPan: "ចុចនិងទាញដើម្បីផ្លាស់ទី",
    useZoomControlsToAdjustSize: "ប្រើប្រាស់ការគ្រប់គ្រងបង្រួម/ពង្រីកដើម្បីកែសម្រួលទំហំ",
    photo: "រូបភាព",
    quantity: "បរិមាណ",
    unit: "ឯកតា",
    requestor: "អ្នកស្នើ",
    yShop: "Y Shop",
    addNewRequest: "បន្ថែមសំណើថ្មី",
    noRequestsYetClickAddNewRequest: "មិនមានសំណើនៅឡើយ។ ចុច \"បន្ថែមសំណើថ្មី\" ដើម្បីបង្កើត។",
    view: "មើល",
    airQualitySensors: "ឧបករណ៍ចាប់សញ្ញាគុណភាពខ្យល់",
    goBack: "ត្រលប់ក្រោយ",
    online: "អនឡាញ",
    sensorNode: "ថ្នាក់ឧបករណ៍ចាប់សញ្ញា",
    temp: "សីតុណ្ហភាព",
    humidity: "សំណើម",
    wasteManagementAnalytics: "ការវិភាគការគ្រប់គ្រងកាកសំណល់",
    totalWaste: "កាកសំណល់សរុប",
    recycled: "កំពុងកែច្នៃ",
    landfill: "ការចោល",
    hazardous: "គ្រោះថ្នាក់",
    composition: "សមាសភាព",
    plastic: "ផ្លាស្ទិក",
    paper: "ក្រដាស",
    monthlyTrend: "ដំណើរការប្រចាំខែ",
    ref: "REF",
    createdDate: "កាលបរិច្ឆេទបង្កើត",
    planDate: "កាលបរិច្ឆេទរៀបចំ",
    finishDate: "កាលបរិច្ឆេទបញ្ចប់",
    viewImage: "មើលរូបភាព",
    addRequest: "បន្ថែមសំណើ",
    looksLikeYouHaveNoRequestsYet: "ហាក់ដូចជាអ្នកមិនមានសំណើនៅឡើយ!",
    needHelpSubmitTicket: "ត្រូវការជំនួយ? ដាក់ស្នើសំបុត្រ ហើយយើងនឹងរីករាយក្នុងការជួយអ្នក។",
    yes: "បាទ/ចាស",
    viewSupportTicketImage: "មើលរូបភាពសំបុត្រជំនួយ",
    addNewSupportRequest: "បន្ថែមសំណើជំនួយថ្មី",
    billRecord: "កំណត់ត្រាវិក្កយបត្រ",
    addBillRecord: "បន្ថែមកំណត់ត្រាវិក្កយបត្រ",
    noBillRecordsFound: "មិនបានរកឃើញកំណត់ត្រាវិក្កយបត្រ។",
    selectDepartment: "ជ្រើសនាយកដ្ឋាន",
    enterTopic: "បញ្ចូលប្រធានបទ",
    selectCategory: "ជ្រើសប្រភេទ",
    enterDescription: "បញ្ចូលការពិពណ៌នា",
    selectCurrency: "ជ្រើសរូបិយប័ណ្ណ",
    uploadImage: "ផ្ទុករូបភាព",
    clickToUploadImage: "ចុចដើម្បីផ្ទុករូបភាព",
    preview: "មើលជាមុន",
    bill: "វិក្កយបត្រ",
    close: "បិទ",
    reset: "កំណត់ឡើងវិញ",
    totalUsers: "អ្នកប្រើប្រាស់សរុប",
    gateInOutRecords: "កំណត់ត្រាចូល/ចេញ",
    motorcycleRecords: "កំណត់ត្រាម៉ូតូ",
    carPlateRecords: "កំណត់ត្រាលេខឡាន",
    truckRecords: "កំណត់ត្រាឡានដឹកទំនិញ",
    walkInOut: "ដើរចូល/ចេញ",
    visitorRecord: "កំណត់ត្រាភ្ញៀវ",
    kYMukTuk: "12K YM Tuk Tuk",
    documentsJoiner: "ឧបករណ៍បញ្ចូលឯកសារ",
    showListsRequest: "បង្ហាញបញ្ជីសំណើ",
    masterList: "បញ្ជីមេ",
    purchaserWorkspace: "កន្លែងធ្វើការរបស់អ្នកទិញ",
    myConfirmReceived: "ការបញ្ជាក់របស់ខ្ញុំ",
    verifyPR: "ផ្ទៀងផ្ទាត់ PR",
    approvalPR: "ការអនុម័ត PR",
    payPR: "បង់ PR",
    tbMonthlyYearly: "TB ខែ និងឆ្នាំ",
    toi: "TOI",
    factoryAccounting: "គណនេយ្យរោងចក្រ",
    taxReporting: "របាយការណ៍ពន្ធ",
    checklist6s: "បញ្ជីពិនិត្យ 6s",
    complianceCertificate: "វិញ្ញាបនបត្រអនុលោម",
    auditPlan: "ផែនការសវនកម្ម",
    masterOrganizationChart: "តារាងអង្គភាពមេ",
    customOrganizationChart: "តារាងអង្គភាពផ្ទាល់ខ្លួន",
    leaderWorkerSections: "ផ្នែកអ្នកដឹកនាំ/កម្មករ",
    faceScanLogs: "កំណត់ត្រាស្កេនមុខ",
    myFaceScan: "ការស្កេនមុខរបស់ខ្ញុំ",
    solarDashboard: "ផ្ទាំងគ្រប់គ្រងពន្លឺព្រះអាទិត្យ",
    switchBoardAmpereLoadMonitoring: "ការតាមដានបន្ទុកអំពែរបន្ទះប្តូរ",
    energySource: "ប្រភពថាមពល",
    temperatureHumiditySensor: "ឧបករណ៍ចាប់សីតុណ្ហភាពនិងសំណើម",
    switchFanPump: "ប្តូរ (ផ្លុំ និងបូម)",
    airQualityDetector: "ឧបករណ៍រកឃើញគុណភាពខ្យល់",
    requestWorkerForm: "ទម្រង់ស្នើកម្មករ",
    requestWorkerList: "បញ្ជីស្នើកម្មករ",
    cambodiaEInvoice: "វិក្កយបត្រអេឡិចត្រូនិចកម្ពុជា",
    supplierManagement: "ការគ្រប់គ្រងអ្នកផ្គត់ផ្គង់",
    iews: "IEWS",
    qcFile: "ឯកសារ QC",
    preProductionMeeting: "កិច្ចប្រជុំមុនផលិតកម្ម",
    firstOutputCutting: "លទ្ធផលដំបូងកាត់",
    firstOutputPrintingEmbroidery: "លទ្ធផលដំបូងបោះពុម្ពនិងប៉ាក់",
    firstOutputSewing: "លទ្ធផលដំបូងកាត់",
    qaCutting: "QA កាត់",
    qaPrintingEmbroidery: "QA បោះពុម្ពនិងប៉ាក់",
    qa20pcsAudit: "QA សវនកម្ម 20pcs",
    inlineAuditRolling: "សវនកម្មជួរដេក",
    offlineAudit: "សវនកម្មក្រៅបន្ទាត់",
    qcEndLineChecking: "QC ពិនិត្យបន្ទាត់បញ្ចប់",
    internalRollingQC: "QC ជួរដេកខាងក្នុង",
    cuttingInspection: "ការពិនិត្យកាត់",
    cutPanelInspection: "ការពិនិត្យបន្ទះកាត់",
    printingInspection: "ការពិនិត្យបោះពុម្ព",
    embroideryInspection: "ការពិនិត្យប៉ាក់",
    garmentCheckOutput: "លទ្ធផលពិនិត្យសម្លៀកបំពាក់",
    finishingInspection: "ការពិនិត្យបញ្ចប់",
    ironingInspection: "ការពិនិត្យអ៊ុត",
    packingInspection: "ការពិនិត្យវេចខ្ចប់",
    preFinalInspection: "ការពិនិត្យចុងក្រោយមុន",
    finalInspection: "ការពិនិត្យចុងក្រោយ",
    buyerFinalInspection: "ការពិនិត្យចុងក្រោយអ្នកទិញ",
    supplierEvaluation: "ការវាយតម្លៃអ្នកផ្គត់ផ្គង់",
    customerComplainCap: "ការតវ៉ារបស់អតិថិជន Cap",
    fabricReceiving: "ការទទួលក្រណាត់",
    fabricInspection: "ការពិនិត្យក្រណាត់",
    fabricTest: "ការធ្វើតេស្តក្រណាត់",
    consumptions: "ការប្រើប្រាស់",
    calculator: "ម៉ាស៊ីនគិតលេខ",
    fabricIssuing: "ការចេញក្រណាត់",
    deliveryTracking: "ការតាមដានការដឹកជញ្ជូន",
    returnFabric: "ត្រឡប់ក្រណាត់",
    returnAccessories: "ត្រឡប់គ្រឿងបន្ថែម",
    brandProtection: "ការការពារម៉ាក",
    onlineTraining: "ការបណ្តុះបណ្តាលអនឡាញ",
    shipping: "ការដឹកជញ្ជូន",
    ppc: "PPC",
    merchandising: "ការលក់",
    purchasing: "ការទិញ",
    generalAffairs: "កិច្ចការទូទៅ",
    financial: "ហិរញ្ញវត្ថុ",
    cbsa: "CBSA",
    sample: "គំរូ",
    technical: "បច្ចេកទេស",
    rawMaterialWarehouse: "ឃ្លាំងវត្ថុធាតុដើម",
    scc: "SCC",
    tpm: "TPM",
    warehouse: "ឃ្លាំង",
    ie: "IE",
    qaFabric: "QA (ក្រណាត់)",
    production: "ផលិតកម្ម",
    dashboard: "ផ្ទាំងគ្រប់គ្រង",
    report: "របាយការណ៍",
    ccf: "CCF",
    misti: "MISTI",
    owso: "OWSO",
    eFiling: "E-Filing",
    nssf: "NSSF",
    preProduction: "មុនផលិតកម្ម",
    firstOutput: "លទ្ធផលដំបូង",
    cut: "កាត់",
    washing: "ការបោកខោអាវ",
    rainWaterCollect: "ការប្រមូលទឹកភ្លៀង",
    building1: "អាគារ 1",
    building2: "អាគារ 2",
    building3: "អាគារ 3",
    staffRoom: "បន្ទប់បុគ្គលិក",
    directProductionWaste: "កាកសំណល់ផលិតកម្មផ្ទាល់",
    generalWaste: "កាកសំណល់ទូទៅ",
    addWaste: "បន្ថែមកាកសំណល់",
    useWaste: "ប្រើប្រាស់កាកសំណល់",
    quantityKg: "បរិមាណ (គីឡូក្រាម)",
    wasteKg: "កាកសំណល់ (គីឡូក្រាម)",
    preAudit: "មុនសវនកម្ម",
    onSiteAudit: "សវនកម្មនៅកន្លែង",
    reporting: "របាយការណ៍",
    reportingAssessment: "របាយការណ៍ និងការវាយតម្លៃ",
    postAudit: "ក្រោយសវនកម្ម",
    inProgress: "កំពុងដំណើរការ",
    activityAuditPlan: "ផែនការសវនកម្មសកម្មភាព",
    trackTheProgress: "តាមដានដំណើរការនៃសកម្មភាពសវនកម្មតាមដំណាក់កាលនីមួយៗ",
    viewAuditPlan: "មើលផែនការសវនកម្ម",
    addAuditPlan: "បន្ថែមផែនការសវនកម្ម",
    auditPlanList: "បញ្ជីផែនការសវនកម្ម",
    auditDetails: "ព័ត៌មានលម្អិតសវនកម្ម",
    totalReports: "សរុប",
    reports: "របាយការណ៍",
    planningPreparation: "ការរៀបចំផែនការ",
    verificationFinal: "ការផ្ទៀងផ្ទាត់ និងចុងក្រោយ",
    syncToDrive: "Sync to Drive",
    allAudits: "សវនកម្មទាំងអស់",
    addAudit: "បន្ថែមសវនកម្ម",
    import: "នាំចូល",
    export: "នាំចេញ",
    editAudit: "កែសម្រួលសវនកម្ម",
    explanation: "ការពន្យល់",
    sourceConsulted: "ប្រភពពិគ្រោះ",
    legalReference: "ឯកសារយោងផ្លូវច្បាប់",
    contents: "មាតិកា",
    issue: "បញ្ហា",
    attachments: "ឯកសារភ្ជាប់",
    seeMore: "មើលបន្ថែម",
    temperatureHumiditySensorDeviceList: "បញ្ជីឧបករណ៍ចាប់សីតុណ្ហភាពនិងសំណើម",
    newBoiler: "ឡចំហុះថ្មី",
    pressing: "ការអ៊ុត",
    airCompressor: "ម៉ាស៊ីនបង្ហាប់ខ្យល់",
    secondarySP: "SP ទីពីរ",
    rawPileSource: "ប្រភពពូជដើម",
    oilbox: "ប្រអប់ប្រេង",
    generator: "ម៉ាស៊ីនភ្លើង",
    coolingSystem: "ប្រព័ន្ធត្រជាក់",
    heatingUnit: "ឯកតាកំដៅ",
    ventilation: "ខ្យល់ចេញចូល",
    lightingSystem: "ប្រព័ន្ធភ្លើង",
    motorA: "ម៉ូទ័រ A",
    motorB: "ម៉ូទ័រ B",
    pumpSystem: "ប្រព័ន្ធបូម",
    compressor2: "ម៉ាស៊ីនបង្ហាប់ 2",
    boiler2: "ឡចំហុះ 2",
    turbine: "តួប៊ីន",
    transformer: "ឧបករណ៍បំប្លែង",
    switchGear: "បន្ទះប្តូរ",
    controlPanel: "បន្ទះគ្រប់គ្រង",
    device: "ឧបករណ៍",
    fabricInspection: "ការពិនិត្យក្រណាត់",
    fabricWHD: "ក្រណាត់ WHD",
    qaRoom: "បន្ទប់ QA",
    assemblingRoom: "បន្ទប់ផ្គុំ",
    supervisorRoom: "បន្ទប់អ្នកគ្រប់គ្រង",
    fabricFolding: "ការបត់ក្រណាត់",
    deliverallyRoom: "បន្ទប់ដឹកជញ្ជូន",
    sewingC: "កាត់ C",
    windingDept: "នាយកដ្ឋានវិល",
    fabricReleasing: "ការចេញក្រណាត់",
    uggirSewingB: "UGGIR កាត់ B",
    rcc: "RCC",
    sewingA: "កាត់ A",
    finishGoodsWHD: "ទំនិញបញ្ចប់ WHD",
    example: "ឧទាហរណ៍",
    cartonKeepingArea: "តំបន់រក្សាទុកប្រអប់",
    finishing: "ការបញ្ចប់",
    directProductionWasteCutting: "កាកសំណល់ផលិតកម្មផ្ទាល់ (កាត់)",
    directProductionWasteSewing: "កាកសំណល់ផលិតកម្មផ្ទាល់ (កាត់)",
    generalWasteOrganicWaste: "កាកសំណល់ទូទៅ (កាកសំណល់សរីរាង្គ)",
    generalWasteConfused: "កាកសំណល់ទូទៅ (ច្របូកច្របល់)",
    wasteProductAnalytics: "ការវិភាគផលិតផលកាកសំណល់",
    exportAsPDF: "នាំចេញជា PDF",
    showing: "បង្ហាញ",
    onThisPage: "នៅលើទំព័រនេះ",
    auditLocation: "ទីតាំងសវនកម្ម",
    auditForm: "ទម្រង់សវនកម្ម",
    activityProcessFlow: "លំហូរដំណើរការសកម្មភាព",
    noAuditPlansFound: "មិនបានរកឃើញផែនការសវនកម្ម",
    meters: "ម៉ែត្រ",
    metersDeviceList: "បញ្ជីឧបករណ៍ម៉ែត្រ",
    exportAllMetersRecord: "នាំចេញកំណត់ត្រាម៉ែត្រទាំងអស់",
    hourlyReport: "របាយការណ៍ម៉ោង",
    totalDevice: "ឧបករណ៍សរុប",
    totalEnergyConsumed: "ថាមពលប្រើប្រាស់សរុប",
    energyConsumedA: "ថាមពលប្រើប្រាស់ A",
    energyConsumedB: "ថាមពលប្រើប្រាស់ B",
    energyConsumedC: "ថាមពលប្រើប្រាស់ C",
    energyConsumedD: "ថាមពលប្រើប្រាស់ D",

    // Energy - Switch Board
    switchBoardList: "បញ្ជី Switch Board",
    switchBoards: "Switch Boards",
    monitorAllRegisteredSwitchBoards: "តាមដាន switch boards ទាំងអស់ដែលបានចុះបញ្ជី និងឧបករណ៍ដែលតភ្ជាប់នៅក្នុងមួយភ្លែត។",
    importExcel: "នាំចូល Excel",
    addSwitchBoard: "បន្ថែម Switch Board",
    viewDetails: "មើលព័ត៌មានលម្អិត",
    equipmentCount: "ចំនួនឧបករណ៍",
    totalSwitchBoards: "Switch Boards សរុប",
    totalEquipments: "ឧបករណ៍សរុប",
    averageEquipments: "ឧបករណ៍មធ្យម / Board",

    // Air - Air Quality Detector
    airQualityDetectorDeviceList: "បញ្ជីឧបករណ៍រកឃើញគុណភាពខ្យល់",

    // Waste - Boiler
    boiler: "Boiler",
    addBoiler: "បន្ថែម Boiler",
    export: "នាំចេញ",
    steamBoiler: "Steam Boiler",
    hotWaterBoiler: "Hot Water Boiler",
    wasteHeatBoiler: "Waste Heat Boiler",
    electricBoiler: "Electric Boiler",
    totalBoiler: "Boiler សរុប",
    daysTracked: "ថ្ងៃដែលតាមដាន",

    // Digital Audit - Compliance Certificate
    complianceCertificate: "វិញ្ញាបនបត្រអនុលោម",
    search: "ស្វែងរក",
    reset: "កំណត់ឡើងវិញ",
    ministryType: "ប្រភេទក្រសួង",
    auditType: "ប្រភេទសវនកម្ម",
    all: "ទាំងអស់",
    certificateName: "ឈ្មោះវិញ្ញាបនបត្រ",
    ministry: "ក្រសួង",
    issueDate: "កាលបរិច្ឆេទចេញ",
    expiredDate: "កាលបរិច្ឆេទផុតកំណត់",
    validityPeriod: "រយៈពេលសុពលភាព",
    renewalDate: "កាលបរិច្ឆេទធ្វើឡើងវិញ",
    responsiblePerson: "អ្នកទទួលខុសត្រូវ",
    valid: "មានសុពលភាព",
    expired: "ផុតកំណត់",
    viewCertificate: "មើលវិញ្ញាបនបត្រ",
    noCertificatesFound: "រកមិនឃើញវិញ្ញាបនបត្រ",

    // Purchase Request - Approval
    requestDetails: "ព័ត៌មានលម្អិតសំណើ",
    approvalApplicationList: "បញ្ជីសំណើអនុម័ត",
    accountantApproval: "ការអនុម័តគណនេយ្យ",
    accountantApprovalAndPayment: "ការអនុម័តនិងការបង់ប្រាក់គណនេយ្យ",
    approvedAndPaid: "បានអនុម័ត & បានបង់",

    // Call Out / KANBAN
    allLocation: "ទីតាំងទាំងអស់",
    refresh: "ធ្វើឱ្យស្រស់",
    exit: "ចេញ",
    line1: "បន្ទាត់ 1",
    line2: "បន្ទាត់ 2",
    line3: "បន្ទាត់ 3",
    line4: "បន្ទាត់ 4",
    line5: "បន្ទាត់ 5",
    line6: "បន្ទាត់ 6",
    line7: "បន្ទាត់ 7",
    line8: "បន្ទាត់ 8",
    line9: "បន្ទាត់ 9",
    line10: "បន្ទាត់ 10",
    line11: "បន្ទាត់ 11",

    // CE Module
    stStandardTime: "ST Standard Time",
    productDevelopment: "ការអភិវឌ្ឍផលិតផល",
    garmentAnalysis: "ការវិភាគសម្លៀកបំពាក់",
    cutSewPackProductivity: "ផលិតភាព Cut,Sew,Pack",
    machineAllocation: "ការបែងចែកម៉ាស៊ីន",
    skillInventory: "បញ្ជីជំនាញ",
    teamPerformance: "ការអនុវត្តក្រុម",
    learningCurve: "ខ្សែកោងការរៀនសូត្រ",
    downtimes: "ពេលវេលារងចាំ",
    costCentersDirectIndirectCost: "មជ្ឈមណ្ឌលថ្លៃដើម, ថ្លៃដើមផ្ទាល់/ប្រយោល",
    cpm: "CPM",
    styleCosting: "ការគណនាថ្លៃដើមរចនា",

    // FC Module
    accessoriesReceiving: "ការទទួលគ្រឿងបន្ថែម",
    accessoriesInspection: "ការពិនិត្យគ្រឿងបន្ថែម",
    accessoriesIssuing: "ការចេញគ្រឿងបន្ថែម",
    warehouseTrackingLocation: "ទីតាំងតាមដានឃ្លាំង",

    // YQMS - Final Production
    qaAuditFinishingPacking: "QA សវនកម្មបញ្ចប់ការវេចខ្ចប់",
    humidityAquaboyChecking: "ការត្រួតពិនិត្យសំណើម Aquaboy",
    firstOutputFinishingAndPacking: "ការបញ្ចប់លទ្ធផលដំបូង និងការវេចខ្ចប់",
    finCheckSetting: "FinCheck ការកំណត់ការកំណត់",
    finCheckReport: "FinCheck របាយការណ៍",
    finCheckTemplate: "FinCheck ប្រើប្រាស់",
    finCheckInspection: "FinCheck ពិនិត្យ",
    finCheckUpload: "FinCheck នាំចូល",
    P88Legacy: "P88 បញ្ជី",

    // Compliance Certificate - Additional
    certificateAndReport: "វិញ្ញាបនបត្រ និងរបាយការណ៍",
    typeOfMinistries: "ប្រភេទក្រសួង",
    searchByCertificateIdOrName: "ស្វែងរកតាមលេខសម្គាល់ឬឈ្មោះវិញ្ញាបនបត្រ",
    fromDate: "ពីកាលបរិច្ឆេទ",
    toDate: "ដល់កាលបរិច្ឆេទ",
    ministryPermits: "ការអនុញ្ញាតក្រសួង",
    addCertificate: "បន្ថែមវិញ្ញាបនបត្រ",
    importPermits: "នាំចូលការអនុញ្ញាត",
    history: "ប្រវត្តិ",
    exportPermits: "នាំចេញការអនុញ្ញាត",
    certificatesList: "បញ្ជីវិញ្ញាបនបត្រ",
    totalCertificates: "សរុប",
    showingOnThisPage: "បង្ហាញ",
    onThisPage: "នៅលើទំព័រនេះ",
    notAvailable: "មិនមាន",
    viewPdf: "មើល PDF",
    certificateImage: "រូបភាពវិញ្ញាបនបត្រ",
    ministrySupplier: "ក្រសួង/អ្នកផ្គត់ផ្គង់",
    actions: "សកម្មភាព",
    status: "ស្ថានភាព",
    showingResults: "បង្ហាញ",
    to: "ដល់",
    of: "នៃ",
    year: "ឆ្នាំ",
    years: "ឆ្នាំ",
    days: "ថ្ងៃ",
    certificate: "វិញ្ញាបនបត្រ",
    certificates: "វិញ្ញាបនបត្រ",
    board: "ក្តារ",
    equipments: "ឧបករណ៍",

    // Water Module
    waterProductList: "បញ្ជីផលិតផលទឹក",
    totalWaterConsumed: "ទឹកប្រើប្រាស់សរុប",
    waterMeter: "ម៉ែត្រទឹក",

    // Phone Viewer
    phoneScreenshots: "រូបភាពអេក្រង់ទូរស័ព្ទ",
    images: "រូបភាព",
    useArrowKeys: "ប្រើប្រាស់គ្រាប់ចុចព្រួញ ឬប៊ូតុងដើម្បីរុករក",
    homePage: "ទំព័រដើម",
    web: "វេប",
    selectModule: "ជ្រើសរើសម៉ូឌុលមួយដើម្បីមើលរូបភាពអេក្រង់ទូរស័ព្ទ"
};

export default translations;
